<template>
    <div class="FlexFundsOverview" style="display:flex;flex-direction:column; max-height:85vh; overflow-y:auto;">
            <div ref="divtophalf">
                <h2>Flex Fund Expenditures <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="GetTransactions()" class="olive-green-text pointer" /> <font-awesome-icon :icon="['fa', 'plus']" @click="OpenNewTransaction()" class="pointer" /> <font-awesome-icon :icon="['fa', 'download']" @click="DownloadTransactions()" class="pointer" /> <span v-b-tooltip.hover title="Hide/Show Filters"><font-awesome-icon :icon="ShowFilters ? 'eye' : 'eye-slash'" v-on:click="ToggleShowFilters()" class="pointer" /></span></h2>
                <form class="table-filters client-list" v-show="ShowFilters">
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Dispersed On/After:</label>
                                <flat-pickr class="form-control" :config="DateConfig" v-model="Filters.DispersedStartDate"></flat-pickr>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Receipts On/After:</label>
                                <flat-pickr class="form-control" :config="DateConfig" v-model="Filters.ReceiptStartDate"></flat-pickr>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Expenditure Form On/After::</label>
                                <flat-pickr class="form-control" :config="DateConfig" v-model="Filters.ExpenditureStartDate"></flat-pickr>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Transaction Balanced:</label>
                                <select class="form-control" v-model="Filters.TransactionIsBalanced">
                                    <option value=""></option>
                                    <option :value="true">YES</option>
                                    <option :value="false">NO</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Dispersed On/Before:</label>
                                <flat-pickr class="form-control" :config="DateConfig" v-model="Filters.DispersedEndDate"></flat-pickr>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Receipts On/Before:</label>
                                <flat-pickr class="form-control" :config="DateConfig" v-model="Filters.ReceiptEndDate"></flat-pickr>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Expenditure Form On/Before::</label>
                                <flat-pickr class="form-control" :config="DateConfig" v-model="Filters.ExpenditureEndDate"></flat-pickr>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Client:</label>
                                <v-select :options="ClientEnrollmentsList" label="text" :reduce="option => option.value" v-model="Filters.ClientSubProgramMembershipID">
                                    <template #search="{attributes, events}">
                                        <input class="vs__search"
                                               v-bind="attributes"
                                               v-on="events" />
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label>Search Records:</label>
                                <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label>Type:</label>
                                <select class="form-control" v-model="Filters.TransactionType">
                                    <option value=""></option>
                                    <option value="Cash">Cash</option>
                                    <option value="Credit">Credit</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label>Program:</label>
                                <select @change="GetEmployees" class="form-control" v-model="Filters.SubProgramID">
                                    <option value="12E83DA9-E178-4DB2-9077-6097F277443A">Inland/Desert Wrap</option>
                                    <option value="6F2DB8BF-8181-48EA-856C-63B12EC45CC8">Inland Private Wrap</option>
                                    <option value="446CB3EF-6BEF-4852-8673-C3CAB76F31C9">Inland School Wrap</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label>Employee:</label>
                                <v-select :options="Employees" label="Name" :reduce="option => option.Id" v-model="Filters.SpenderEmployeeID">
                                    <template #search="{attributes, events}">
                                        <input class="vs__search"
                                               v-bind="attributes"
                                               v-on="events" />
                                    </template>
                                </v-select>
                            </div>
                        </div>


                    </div>
                </form>
            </div>
            <div style="overflow:auto; min-height:20vh;">
                <vuetable :fields="Fields"
                          pagination-path=""
                          :api-mode="false"
                          class="vue-datatable"
                          :data-manager="DataManager"
                          ref="datatable"
                          id="flexfundsdatatable">

                    <template slot="Operations" scope="props">
                        <div class="Operations">
                            <font-awesome-icon :icon="['fa', 'edit']" @click="OpenExistingTransaction(props.rowData)" class="pointer" /> <a v-if="props.rowData.ReceiptFileID" :href="GetReceiptLink(props.rowData.ReceiptFileID)" target="_blank"><font-awesome-icon :icon="['fa', 'eye']" /></a>
                        </div>
                    </template>
                </vuetable>
            </div>
        


        <!--CREATE NEW TRANSACTION-->
        <b-modal ref="modal-transaction" size="lg" title="Flex Fund Expenditure" hide-footer>
            <b-container>
                <b-form @submit="SaveTransaction">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Category:</label>
                                <select class="form-control" v-model="TargetTransaction.ExpenseType" required>
                                    <option value="Client">Client Expense</option>
                                    <option value="PPLSG">PPLSG Expense</option>
                                    <option value="Other">Other Expense (see notes)</option>
                                </select>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Type:</label>
                                <select class="form-control" v-model="TargetTransaction.TransactionType" required>
                                    <option value="Credit">Credit</option>
                                    <option value="Cash">Cash</option>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group" v-if="TargetTransaction.ExpenseType == 'Client'">
                                <label>Client:</label>
                                <v-select :options="ClientEnrollmentsList" label="text" :reduce="option => option.value" v-model="TargetTransaction.ClientSubProgramMembershipID">
                                    <template #search="{attributes, events}">
                                        <input class="vs__search"
                                               v-bind="attributes"
                                               v-on="events" />
                                    </template>
                                </v-select>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Employee:</label>
                                <v-select :options="Employees" label="Name" :reduce="option => option.Id" v-model="TargetTransaction.SpenderEmployeeID">
                                    <template #search="{attributes, events}">
                                        <input class="vs__search"
                                               v-bind="attributes"
                                               v-on="events" />
                                    </template>
                                </v-select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Funds Dispersed On:</label>
                                <flat-pickr v-model="TargetTransaction.DispersedDate" class="form-control" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Dispersed Amount:</label>
                                <input type="text" v-model="TargetTransaction.DispersedAmount" class="form-control" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Expenditure Form Submitted On:</label>
                                <flat-pickr v-model="TargetTransaction.ExpenditureFormReturnedDate" class="form-control" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Change Returned:</label>
                                <input type="text" v-model="TargetTransaction.ReturnedAmount" class="form-control" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Receipt Date:</label>
                                <flat-pickr v-model="TargetTransaction.ReceiptDate" class="form-control" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Receipt Amount:</label>
                                <input type="text" v-model="TargetTransaction.ReceiptAmount" class="form-control" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Purpose Code(s):</label>
                                <p>1=Food 2=Housing 3=Utilities 4=ExtraCurricular 5=Education 6=Celebration 7=Incentive 8=Clothing 9=One-on-One 10=Coping 11=Transportation 12=Medical</p>
                                <input type="text" v-model="TargetTransaction.PurposeCodes" class="form-control" />
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Domain Code(s):</label>
                                <p>1=Safety 2=Family 3=Legal 4=Emothional/Behavioral 5=School/Educational 6=MoneyMatters 7=Housing/Living Environment 8=SocialRelationship 9=Fun/Recreational 10=Health/Medical 11=Work/vocational 12=Cultural/Spiritual</p>
                                <input type="text" v-model="TargetTransaction.DomainCodes" class="form-control" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Notes:</label>
                                <textarea rows="4" v-model="TargetTransaction.Notes" class="form-control"></textarea>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div v-if="!TargetTransaction.ReceiptFileID" class="form-group">
                                <label>Expenditure Form:</label>
                                <b-form-file v-model="TargetTransaction.ReceiptFileData" 
                                             class="form-control"
                                             accept=".pdf">
                                </b-form-file>
                            </div>
                            <div v-else class="form-group">
                                <label>Expenditure Form:</label>
                                <p><a :href="GetReceiptLink(TargetTransaction.ReceiptFileID)" target="_blank"><font-awesome-icon :icon="['fa', 'eye']" /></a></p>
                                <p><font-awesome-icon @click="RemoveReceipt()" :icon="['fa', 'trash-alt']" class="pointer red" /></p>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelTransaction()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                            <b-button v-if="TargetTransaction.Id" size="md" variant="danger" @click="DeleteTransaction()">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <DocumentViewer ref="document-viewer-modal-component" :reviewing="false" />
    </div>
</template>

<script>
    //import components
    import { EventBus } from '../../../services/event-bus.js';
    import Vuetable from 'vuetable-2/src/components/Vuetable'

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faDownload } from '@fortawesome/free-solid-svg-icons';
    library.add(faDownload);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faEye } from '@fortawesome/free-solid-svg-icons';
    library.add(faEye);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
    library.add(faEyeSlash);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);

    import DocumentViewer from "../../Core/RecordComponents/DocumentViewer.vue";
    import { TableScrollerSupport } from "../../../mixins/TableScrollerSupport.js";

    export default {
        mixins: [TableScrollerSupport],
        data: function () {
            return {
                search: "",
                TargetTransaction: {},
                TransactionsData: [],
                Employees: [],
                Filters: {
                    DispersedStartDate: "",
                    DispersedEndDate: "",
                    ReceiptStartDate: "",
                    ReceiptEndDate: "",
                    ExpenditureStartDate: "",
                    ExpenditureEndDate: "",
                    TransactionIsBalanced: "",
                    SpenderEmployeeID: "",
                    ClientSubProgramMembershipID: "",
                    TransactionType: "",
                    ExpenseType: "",
                    HasReceiptAttachment: "",
                    HasAdditionalAttachment: "",
                    SubProgramID: "12E83DA9-E178-4DB2-9077-6097F277443A",
                },
                TransactionSchema: {
                    Id: "",
                    ReceiptAmount: "",
                    ReceiptDate: "",
                    DispersedDate: "",
                    DispersedAmount: "",
                    ExpenditureFormReturnedDate: "",
                    ReturnedAmount: "",
                    ExpenseType: "",
                    TransactionType: "",
                    Notes: "",
                    PurposeCodes: "",
                    DomainCodes: "",
                    ReportedDate: "",
                    ClientSubProgramMembershipID: "",
                    SpenderEmployeeID: ""
                },
                Fields: [
                    
                    {
                        name: 'DispersedDate',
                        sortField: 'DispersedDate',
                        title: 'Dispersed',
                        callback: 'formatDate|MM/DD/YY'
                    },
                    {
                        name: 'ReceiptDate',
                        sortField: 'ReceiptDate',
                        title: 'Receipt',
                        callback: 'formatDate|MM/DD/YY'
                    },
                    {
                        name: 'ExpenseType',
                        sortField: 'ExpenseType',
                        title: 'Category',
                    },
                    {
                        name: 'TransactionType',
                        sortField: 'TransactionType',
                        title: 'Type',
                    },
                    {
                        name: 'ClientName',
                        sortField: 'ClientName',
                        title: 'Client',
                    },
                    {
                        name: 'SpenderEmployee.Person.FullName',
                        sortField: 'SpenderEmployee.Person.FullName',
                        title: 'Employee',
                    },
                    {
                        name: 'ReceiptAmount',
                        sortField: 'ReceiptAmount',
                        title: 'Amount',
                    },
                    {
                        name: 'TransactionIsBalanced',
                        sortField: 'TransactionIsBalanced',
                        title: 'Balanced?',
                        callback: 'balancedYesNo'
                    },
                    {
                        name: '__slot:Operations',
                        title: 'Edit',
                    }
                ],
                
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                },
            };
        },
        methods: {
            GetTransactions() {
                this.$MasterAPI.ExecuteRequest("GET", "Wraparound/FlexFunds/GetTransactions", this.Filters, this.GetTransactionsSuccess, () => { }, true);
            },
            GetTransactionsSuccess(response) {
                this.TransactionsData = response.data.data;
                this.RedrawTable();
            },
            DownloadTransactions() {
                this.$MasterAPI.ExecuteFileRequest("Wraparound/FlexFunds/DownloadTransactions", this.Filters);
            },
            GetEmployees() {
                this.$MasterAPI.ExecuteRequest("GET", "Wraparound/FlexFunds/GetEmployees", {SubProgramID: this.Filters.SubProgramID}, this.GetEmployeesSuccess, () => { }, true);
            },
            GetEmployeesSuccess(response) {
                this.Employees = response.data.data;
            },
            SaveTransaction(e) {
                e.preventDefault();
                let vm = this;
                console.log(this.TargetTransaction.ReceiptFileData);
                const formData = new FormData();
                for (var key in vm.TargetTransaction) {
                    if (vm.TargetTransaction[key] != null) {
                        formData.append(key, vm.TargetTransaction[key]);
                    }
                }
                //formData.append('my-file', inp.files[0], 'file.ext');
                this.$MasterAPI.ExecuteRequest("POST", "Wraparound/FlexFunds/SaveTransaction", formData, this.SaveTransactionSuccess, () => { }, true);
            },
            SaveTransactionSuccess(response) {
                this.GetTransactions();
                this.$refs["modal-transaction"].hide();
            },
            OpenExistingTransaction(rowData) {
                this.TargetTransaction = JSON.parse(JSON.stringify(rowData));
                this.$refs["modal-transaction"].show();
            },
            OpenNewTransaction() {
                this.TargetTransaction = JSON.parse(JSON.stringify(this.TransactionSchema));
                this.$refs["modal-transaction"].show();
            },
            DeleteTransaction() {
                this.$MasterAPI.ExecuteRequest("POST", "Wraparound/FlexFunds/DeleteTransaction", { Id: this.TargetTransaction.Id }, this.DeleteTransactionSuccess, () => { }, true);
            },
            DeleteTransactionSuccess(response) {
                this.GetTransactions();
                this.$refs["modal-transaction"].hide();
            },
            CancelTransaction() {
                this.$refs["modal-transaction"].hide();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.TransactionsData);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }

                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));

                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                this.NumberOfClients = visibleData.length;
                return visibleData;
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            formatDate(value, fmt = 'MM/DD/YY', defaultVal = '') {
                return (value == null)
                    ? defaultVal
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            balancedYesNo(value) {
                return (value)
                    ? "YES"
                    : "NO"
            },
            GetReceiptLink(fileID) {
                return this.$baseURL + "/API/Core/Files/GetFileContent/Receipt.pdf?FileID=" + fileID;
            },
            RemoveReceipt() {
                this.TargetTransaction.ReceiptFileID = null;
            }
        },
        components: {
            DocumentViewer,
            flatPickr,
            vSelect,
            Vuetable
        },
        mounted() {
            this.Filters.DispersedStartDate = moment().add(-60, "days").format("YYYY-MM-DD");

            this.GetEmployees();
            this.GetTransactions();
        },
        computed: {
            ClientEnrollmentsList: function () {
                let vm = this;
                let output = [];

                this.$store.state.Clients.ClientEnrollmentsList.forEach(function (i) {
                    output.push(
                        {
                            text: i.ClientName + ' REF: ' + vm.formatDate(i.ReferralDate),
                            value: i.Id
                        });
                });
                return output;
            },
        },
    }
</script>

<style scoped>
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position: sticky;
        top: -1px;
        background: white;
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }
</style>